{{ normalizedValue() }}
@if (uom()) {
  <span>{{ uom() }}</span>
}
